<template v-if="!isLoading">
  <toast-notification ref="notification" />
  <div>
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>
    <ol
      v-if="!this.$router.currentRoute.value.path.includes('invoiceList')"
      class="process-steps process-steps-primary text-muted m-1"
    >
      <li
        class="process-step-item"
        v-if="
          this.$router.currentRoute.value.fullPath.includes(
                        'reservingSessionTab'
                      )
        "
        :class="
          this.$router.currentRoute.value.path.includes('selectTherapist')
            ? 'active'
            : 'complete'
        "
      >
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-person-check-fill ms-1"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
          ></path>
          <path
            d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
          ></path>
        </svg>
        درمانگر
      </li>
      <li
        class="process-step-item"
        :class="
          this.$router.currentRoute.value.path.includes('filteringMore') ||
          this.$router.currentRoute.value.path.includes('selectTestSession')
            ? 'active'
            : this.$router.currentRoute.value.path.includes(
                'sessionTableView'
              ) || this.$router.currentRoute.value.path.includes('finalConfirm')
            ? 'complete'
            : ''
        "
      >
        <svg
          width="16px"
          height="16px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-filter-circle-fill ms-1"
          viewBox="0 0 16 16"
        >
          <path
            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM3.5 5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zM5 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm2 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"
          ></path>
        </svg>
        فیلتر
      </li>
      <li
        class="process-step-item"
        :class="
          this.$router.currentRoute.value.path.includes('sessionTableView')
            ? 'active'
            : this.$router.currentRoute.value.path.includes('finalConfirm')
            ? 'complete'
            : ''
        "
      >
        <svg
          width="16px"
          height="16px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-calendar-range-fill ms-1"
          viewBox="0 0 16 16"
        >
          <path
            d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 7V5H0v5h5a1 1 0 1 1 0 2H0v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9h-6a1 1 0 1 1 0-2h6z"
          ></path>
        </svg>
        جدول
      </li>
      <li class="process-step-item" :class="getFinalConfirmClass">
        <span @click="finalConfirmClick">
          <svg
            width="16px"
            height="16px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-circle-fill ms-1"
            viewBox="0 0 16 16"
          >
            <path
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
            ></path>
          </svg>
          ثبت
        </span>
      </li>
    </ol>

    <template
      v-if="
        semiReserveListCount() != 0 &&
        getHasSessionToReplace() &&
        !this.$router.currentRoute.value.path.includes('finalConfirm')
      "
    >
      <div class="sessionEmpty">
        <p>شما از قبل جلسه‌ای به منظور جابجایی انتخاب کرده‌اید.</p>
        <p>
          به منظور انتخاب
          <b>جلسه‌ای دیگر</b>
          ، ابتدا جلسه رزرو شده را از حالت
          <b>رزرو </b>
          خارج نمایید.
        </p>
        <button
          class="btn btn-sm btn-blueSite"
          @click="
            this.$router.push({
              name: 'finalConfirm',
              params: { id: this.getPersonID },
            })
          "
        >
          <svg
            width="16px"
            height="16px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-circle-fill ms-1"
            viewBox="0 0 16 16"
          >
            <path
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
            ></path>
          </svg>
          ثبت جلسه انتخاب شده
        </button>
        <button
          class="btn btn-outline-danger p-2"
          @click="
            async () => {
              this.semiReserveList().forEach(async (element) => {
                await this.cancelReserveSession(element.sessionID);
              });
            }
          "
        >
          <svg
            width="16px"
            height="16px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-trash"
            viewBox="0 0 16 16"
          >
            <path
              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
            ></path>
          </svg>
          حذف جلسه رزرو شده
        </button>
      </div>
    </template>
    <router-view v-else :entityObject="entity" />
  </div>
  <site-modal
    ID="replacingConfirmationModal"
    :modalSize="getHasSessionToReplace() ? 'semiMedium' : 'small'"
    :modalHasFooter="true"
    @Closed="closedReplacingConfirmationModal"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <i class="fi fi-box-checked"></i>
          {{ getHasSessionToReplace() ? 'تایید جابجایی' : 'تایید رزرو' }}
        </h6>
      </div>
    </template>
    <template #body>
      <div>
        <p>
          شما جلسه‌ای به منظور
          <span class="fw-bold text-danger-gradient fs-5">جابجایی</span>
          انتخاب کرده‌اید، آیا مایل به ادامه این فرآیند هستید؟
        </p>
      </div>
    </template>
    <template #footer>
      <div class="d-flex w-100 justify-content-between">
        <button
          class="btn btn-sm btn-outline-blueSite"
          @click="closedReplacingConfirmationModal()"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-lg"
            viewBox="0 0 16 16"
          >
            <path
              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
            ></path>
          </svg>
          بلی
        </button>
        <button
          class="btn btn-sm btn-outline-danger"
          @click="cancelReplacingSession()"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
            ></path>
          </svg>
          خیر
        </button>
      </div>
    </template>
  </site-modal>
  <site-modal
    ID="cancelReplacingModal"
    modalSize="semiMedium"
    :modalHasFooter="true"
    @Closed="closeCancelReplacingModal"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-arrow-left-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"
            ></path>
          </svg>
          لغو جابجایی
        </h6>
      </div>
    </template>
    <template #body>
      <div>
        <p>
          آیا مایل به لغو عملیات
          <b> جابجایی جلسه</b>
          هستید؟
        </p>
      </div>
    </template>
    <template #footer>
      <div class="d-flex w-100 justify-content-between">
        <button
          class="btn btn-sm btn-outline-blueSite"
          @click="cancelReplacingSession()"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-lg"
            viewBox="0 0 16 16"
          >
            <path
              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
            ></path>
          </svg>
          بلی
        </button>
        <button
          class="btn btn-sm btn-outline-danger"
          @click="closeCancelReplacingModal()"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
            ></path>
          </svg>
          خیر
        </button>
      </div>
    </template>
  </site-modal>
  <site-modal
    ID="waletAmountNoticeModal"
    modalSize="semiMedium"
    :modalHasFooter="true"
    @Closed="closeWaletAmountNoticeModal"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-cash-stack"
            viewBox="0 0 16 16"
          >
            <path
              d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
            ></path>
            <path
              d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z"
            ></path>
          </svg>
          شارژ کیف پول
        </h6>
      </div>
    </template>
    <template #body>
      <div>
        <p>
          با سلام
          <br />
          در صورت تمایل به ثبت جلسه، لطفا ابتدا کیف پول خود را به مقدار لازم
          شارژ کنید.
        </p>
      </div>
    </template>
    <template #footer>
      <div class="w-100">
        <button
          class="btn btn-sm btn-outline-blueSite"
          @click="closeWaletAmountNoticeModal()"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-lg"
            viewBox="0 0 16 16"
          >
            <path
              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
            ></path>
          </svg>
          تایید
        </button>

        <a
          class="btn btn-sm btn-outline-blueSite float-end text-danger"
          href="https://www.aparat.com/v/hbvs98b"
          target="_blank"
        >
          فیلم آموزش شارژ کیف پول
        </a>
      </div>
    </template>
  </site-modal>
</template>
<script>
import { isMobile } from 'mobile-device-detect';
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import { Modal } from 'bootstrap';
import axios from 'axios';
export default {
  components: {
    LoadingSpinner,
  },
  computed: {
    getPersonID() {
      return this.$store.getters.userPersonID;
    },
    getFinalConfirmClass() {
      let classes;
      classes = this.$router.currentRoute.value.path.includes('finalConfirm')
        ? 'active'
        : '';
      classes +=
        this.semiReserveListCount() != 0 ? ' existsSemiReserveSession' : '';
      return classes;
    },
  },
  inject: [
    'semiReserveListCount',
    'semiReserveList',
    'cancelReserveSession',
    'getCurrentDiscountTariffPrice',
  ],
  provide() {
    return {
      nextStep: this.nextStep,
      previousStep: this.previousStep,
      hasSessionToReplace: this.getHasSessionToReplace,
      showCancelReplacingModal: this.showCancelReplacingModal,
      getBackRoutFrom: this.getBackRoutFrom,
    };
  },
  data() {
    return {
      isLoading: true,
      backRoutFrom: '',
      replacingConfirmationModal: new Object(),
      cancelReplacingModal: new Object(),
      waletAmountNoticeModal: new Object(),
      tabState: '',
      clientStatus: 'old',
      isMobile: isMobile,
      clientHasOpenInvoice: false,
      entity: {
        therapistStatus: '',
        therapistID: null,
        therapyTypeID: null,
        therapyTypeTitle: '',
        sessionTypeID: 0,
        scopeIDs: [],
        topicIDs: [],
        approachIDs: [],
        otherAbilityIDs: [],
        ageRangeID: null,
        genderID: null,
        educationID: null,
        personID: 0,
        isOverseas: false,
        therapistList: [],
      },
      replacedSessionEntity: null,
    };
  },
  watch: {
    async $route(to, from) {
      if (
        from.path &&
        (to.fullPath.includes('/panel/reservingSessionTab/selectTherapist') ||
          to.fullPath.includes('/panel/reservingSessionTab/selectTestSession'))
      ) {
        if (this.$store.getters.isOverseas == true) {
          this.waletAmountNoticeModal?.show();
        }

        // if (
        //   this.$store.getters.isOverseas != true &&
        //   to.fullPath.includes('/panel/reservingSessionTab/selectTherapist')
        // ) {
        //   this.$refs.notification.show({
        //     type: 'info',
        //     title: `توجه: خدمات روانپزشکی در ارگانیک مایندد فقط به صورت غیر حضوری ارائه می شود.`,
        //   });
        // }
      }
      if((from.fullPath.includes('reservingSessionTab') && to.fullPath.includes('reservingSessionTestTab')) || 
      (from.fullPath.includes('reservingSessionTestTab') && to.fullPath.includes('reservingSessionTab'))
    ){
        this.resetEntity();
      }
    },
  },

  methods: {
    resetEntity() {
      this.entity = {
        ...this.entity,
        therapistID: null,
        therapyTypeID: null,
        sessionTypeID: 0,
        scopeIDs: [],
        topicIDs: [],
        approachIDs: [],
        otherAbilityIDs: [],
        ageRangeID: null,
        genderID: null,
        educationID: null,
      };
    },
    getBackRoutFrom() {
      return this.backRoutFrom;
    },
    closeWaletAmountNoticeModal() {
      this.waletAmountNoticeModal.hide();
    },
    closeCancelReplacingModal() {
      this.cancelReplacingModal.hide();
    },
    cancelReplacingSession() {
      this.$router.push({
        name: 'selectTherapist',
        params: { id: this.$store.getters.userPersonID },
      });
      this.$store.dispatch('removeSessionForReplacement');
      this.checkReplacementSession();
      this.replacingConfirmationModal.hide();
      this.cancelReplacingModal.hide();
    },
    closedReplacingConfirmationModal() {
      this.replacingConfirmationModal.hide();
    },
    //این متد به منظور به اشتراک گذاری وجود یا عدم وجود جلسه به منظور جابجایی تولید شده است
    getHasSessionToReplace() {
      return this.replacedSessionEntity ? true : false;
    },
    //دو متد زیر به منظور جمع آوری تمامی اطلاعات فیلتر شده کاربر و پاس دادن آن به همه تب ها تولید شده است
    nextStep(value, fromComponentName) {
      //اگر مرحله جاری انتخاب درمانگر باشد
      if (fromComponentName == 'selectTherapist') {
        this.entity.therapistList = value.therapistList;
        if (value.therapistID != 0 && value.therapistID != null) {
          this.entity.therapyTypeID = null;
          this.entity.therapyTypeTitle = '';
          this.entity.scopeIDs = [];
          this.entity.topicIDs = [];
          this.entity.approachIDs = [];
          this.entity.otherAbilityIDs = [];
          this.entity.ageRangeID = null;
          this.entity.genderID = null;
          this.entity.educationID = null;
        }
        this.entity.therapistID = value.therapistID;
        this.entity.therapistStatus = value.therapistStatus;
        this.entity.sessionTypeID = value.sessionTypeID;
        // در صورتیکه در حالت جابجایی جلسه باشد
        if (this.replacedSessionEntity) {
          this.entity.therapyTypeID = this.replacedSessionEntity.therapyTypeID;
          this.entity.therapistID = this.replacedSessionEntity.therapistID;
        }

        // اگر درمانگر انتخاب نشده باشد به مرحله فیلترها میرود
        if (this.entity.therapistID == 0 || this.entity.therapistID == null)
          this.$router.push({
            name: 'filteringMore',
            params: { id: this.$store.getters.userPersonID },
          });
        // اگر دمانگر انتخاب شده باشد مستقیم به مرحله رزرو میرود
        else
          this.$router.push({
            name: 'sessionTableView',
            params: { id: this.$store.getters.userPersonID },
          });
      }
      // اگر مرحله جاری ثبت تست باشد
      if (fromComponentName == 'selectTestSession') {
        this.entity.therapyTypeID = 14; //روانسنجی
        this.entity.scopeIDs = [7]; //حوزه روان‌سنجی
        this.entity.sessionTypeID = value.sessionTypeID;
        this.entity.topicIDs = value.topicIDs;
        this.entity.therapistID = null;
        this.entity.otherAbilityIDs = [];
        this.entity.ageRangeID = null;
        this.entity.genderID = null;
        this.entity.educationID = null;
        this.entity.approachIDs = [];
        this.$router.push({
          name: 'sessionTableViewByTest',
          params: { id: this.$store.getters.userPersonID },
        });
      }
      //اگر مرحله جاری فیلتر ها باشد
      if (fromComponentName == 'filteringMore') {
        this.entity.therapyTypeID = value.therapyTypeID;
        this.entity.therapyTypeTitle = value.therapyTypeTitle;
        this.entity.scopeIDs = value.scopeIDs;
        this.entity.topicIDs = value.topicIDs;
        this.entity.otherAbilityIDs = value.otherAbilityIDs;
        this.entity.ageRangeID = value.ageRangeID;

        this.entity.genderID = value.genderID;
        this.entity.educationID = value.educationID;
        this.entity.approachIDs = value.approachIDs;
        //بعد از تکمیل و دریافت فیلتر ها به مرحله رزرو میرود
        this.$router.push({
          name: 'sessionTableView',
          params: { id: this.$store.getters.userPersonID },
        });
      }
      //اگر مرحله جاری ثبت جلسه باشد.
      if (fromComponentName == 'sessionTableView') {
        this.$router.push({
          name: this.$router.currentRoute.value.fullPath.includes(
                        'reservingSessionTestTab'
                      ) ? 'finalConfirmByTest' : 'finalConfirm',
          params: { id: this.$store.getters.userPersonID },
        });
      }
    },
    previousStep(fromComponentName) {
      switch (fromComponentName) {
        case 'filteringMore': //اگر مرحله جاری فیلتر باشد
          this.$router.push({
            name: 'selectTherapist',
            params: { id: this.$store.getters.userPersonID },
          });
          break;
        case 'sessionTableView': // اگر مرحله جاری جدول جلسات باشد
          //اگر از مرحله ثبت تست آمده بود به همان مرحله برگردد
          if (this.$router.currentRoute.value.fullPath.includes('reservingSessionTestTab')) {
            this.$router.push({
              name: 'selectTestSession',
              params: { id: this.$store.getters.userPersonID },
            });
            return;
          }
          // اگر نوع درمان انتخاب شده بود به فیلترها برود در غیر اینصورت به صفحه انتخاب درمانگر برود
          //و اگر جلسه برای جابجایی بود به مرحله فیلتر ها نرود
          if (
            this.entity.therapyTypeID != 0 &&
            this.entity.therapyTypeID != null &&
            this.getHasSessionToReplace() == false
          )
            this.$router.push({
              name: 'filteringMore',
              params: { id: this.$store.getters.userPersonID },
            });
          else {
            this.$router.push({
              name: 'selectTherapist',
              params: { id: this.$store.getters.userPersonID },
            });
          }
          break;
        case 'finalConfirm':
          if (
            this.entity.therapyTypeID != 0 &&
            this.entity.therapyTypeID != null
          )
            this.$router.push({
              name: this.$router.currentRoute.value.fullPath.includes(
                        'reservingSessionTestTab'
                      ) ? 'sessionTableViewByTest' : 'sessionTableView',
              params: { id: this.$store.getters.userPersonID },
            });
          else {
            this.$router.push({
              name: this.$router.currentRoute.value.fullPath.includes(
                        'reservingSessionTestTab'
                      ) ? 'selectTestSession' : 'selectTherapist',
              params: { id: this.$store.getters.userPersonID },
            });
          }
          break;
      }
    },
    finalConfirmClick() {
      // چنانچه کاربر جلسه‌ای در سبد داشته باشد مجوز رفتن به این صفحه را دارد
      if (this.semiReserveListCount() != 0)
        this.$router.push({
          name: this.$router.currentRoute.value.fullPath.includes(
                        'reservingSessionTestTab'
                      ) ? 'finalConfirmByTest' : 'finalConfirm',
          params: { id: this.$store.getters.clientID },
        });
      else return;
    },
    checkReplacementSession() {
      this.replacedSessionEntity = this.$store.getters.replacedSessionData;
    },
    showCancelReplacingModal() {
      this.cancelReplacingModal.show();
    },
    async checkClientHasInvoice(){
      if (!this.$router.currentRoute.value.path.includes('invoiceList')) {
        let that = this;
        await axios
          .get(
            `/FN/InvoiceHeader/CheckClientHasInvoice?personID=${that.$store.getters.userPersonID}`
          )
          .then((response) => {
            if (response.data) {
              that.clientHasOpenInvoice = true;
              that.$router.push({
                name: 'invoiceList',
                id: this.$store.getters.userPersonID,
              });
            }
          })
          .catch(() => {
            this.$refs.notification.show({
              type: 'error',
              title: `عملیات بررسی صورت وضعیت با خطا مواجه گردید.`,
            });
          });
        }
    }
  },
  async created() {
    await this.checkClientHasInvoice();
  },
  async updated() {
    await this.checkClientHasInvoice();
  },
  async mounted() {
    await this.$store
      .dispatch('setClientWithWallet', this.$store.getters.userPersonID)
      .then(async () => {
        // await this.getCurrentDiscountTariffPrice();

        this.isLoading = false;
        this.waletAmountNoticeModal = new Modal(
          document.getElementById('waletAmountNoticeModal')
        );
        this.cancelReplacingModal = new Modal(
          document.getElementById('cancelReplacingModal'),
          {
            keyboard: false,
            backdrop: 'static',
          }
        );
        this.replacingConfirmationModal = new Modal(
          document.getElementById('replacingConfirmationModal'),
          {
            keyboard: false,
            backdrop: 'static',
          }
        );
        this.entity.isOverseas = this.$store.getters.isOverseas;
        this.entity.personID = this.$store.getters.userPersonID;

        let filterForPreTestReserving =
          this.$store.getters.getFilterForPreTestReserving;
        if (
          filterForPreTestReserving ||
          this.$router.options.history.state.back?.includes(
            'selectTestSession'
          ) ||
          this.$router.currentRoute.value.path.includes('selectTestSession')
        )
          this.backRoutFrom = 'selectTestSession';

        if (filterForPreTestReserving)
          if (
            filterForPreTestReserving.testTypeID != 0 &&
            filterForPreTestReserving.sessionTypeID != 0 &&
            filterForPreTestReserving.sessionTypeID != null
          ) {
            this.entity.therapyTypeID = 14;
            this.entity.scopeIDs = [7];
            this.entity.topicIDs = [filterForPreTestReserving.testTypeID];

            this.entity.sessionTypeID = this.$store.getters.isOverseas
              ? 2
              : filterForPreTestReserving.sessionTypeID;
            this.$store.dispatch('removeFilterForPreTestReserving'); //حذف تمامی فیلتر های حافظه مرورگر
            this.$router.push({
              name: 'sessionTableView',
              params: { id: this.getPersonID },
            });
          }
        let filterForPreReserving =
          this.$store.getters.getFilterForPreReserving;
        if (filterForPreReserving)
          if (
            filterForPreReserving.therapyTypeID != 0 &&
            filterForPreReserving.therapyTypeID != null &&
            filterForPreReserving.sessionTypeID != 0 &&
            filterForPreReserving.sessionTypeID != null &&
            ((filterForPreReserving.therapyTypeID == 1 &&
              filterForPreReserving.scopeIDs.length != 0) ||
              filterForPreReserving.therapyTypeID != 1)
          ) {
            this.entity.therapistStatus = 'dontCareTherapist';
            this.entity.therapyTypeID = filterForPreReserving.therapyTypeID;
            this.entity.sessionTypeID = this.$store.getters.isOverseas
              ? 2
              : filterForPreReserving.sessionTypeID;
            this.entity.scopeIDs = filterForPreReserving.scopeIDs;
            this.$store.dispatch('removeFilterForPreReserving'); //حذف تمامی فیلتر های حافظه مرورگر
            this.$router.push({
              name: 'sessionTableView',
              params: { id: this.getPersonID },
            });
          }
        if (
          performance.navigation.type == performance.navigation.TYPE_RELOAD &&
          !this.$router.currentRoute.value.path.includes('finalConfirm') &&
          !this.$router.currentRoute.value.path.includes('invoiceList') &&
          !this.$router.currentRoute.value.path.includes('selectTestSession') &&
          !filterForPreReserving &&
          !filterForPreTestReserving
        ) {
          this.$router.push({
            name: 'selectTherapist',
            params: { id: this.$store.getters.userPersonID },
          });
        }
        this.checkReplacementSession();
        if (
          this.replacedSessionEntity &&
          !this.$router.options.history.state.back?.includes('sessionsTab')
        )
          this.replacingConfirmationModal.show();

        //اگر مراجع خارج از کشور باشد، شیوه برگزاری فقط غیرحضوری باشد
        if (this.$store.getters.isOverseas == true) {
          this.entity.sessionTypeID = 2;
          this.waletAmountNoticeModal.show();
        }
        // if (
        //   this.$store.getters.isOverseas != true &&
        //   this.$router.currentRoute.value.path.includes('selectTherapist')
        // ) {
        //   this.$refs.notification.show({
        //     type: 'info',
        //     title: `توجه: خدمات روانپزشکی در ارگانیک مایندد فقط به صورت غیر حضوری ارائه می شود.`,
        //   });
        // }
      });
  },
};
</script>
<style scoped>
.disabled-link {
  color: gray !important;
  pointer-events: none;
}
.form-check-input[type='radio'] {
  float: right;
  margin-left: 5px;
  margin-right: 0;
}
.form-check-input:checked {
  background-color: #4c5e74 !important;
}
.accordion-header,
.accordion-button,
.collapsed {
  color: white;
  background-color: #4c5e74;
  border-radius: 5px 5px 0px 0px;
}
.process-step-item {
  border-bottom: 3px solid #cdcdcd;
  color: #cdcdcd;
}
.process-step-item::after {
  border-color: #cdcdcd;
}
.process-steps-primary > .active .process-steps-primary > .complete {
  border-color: #4c5e74;
}
.process-step-item:before {
  border-color: #cdcdcd;
}
.process-steps-primary > .active,
.process-steps-primary > .complete {
  border-bottom-color: #4c5e74;
}
.process-steps-primary > .complete {
  color: #9facbd !important;
}
.process-steps-primary > .active {
  color: #4c5e74;
}
.process-steps-primary > .active:before,
.process-steps-primary > .complete:before {
  border-color: #4c5e74;
}
.accordion-button:after {
  margin-right: 10px;
  color: white;
  filter: invert(100%) sepia(0%) saturate(26%) hue-rotate(88deg)
    brightness(105%) contrast(108%);
}
.accordion-button:not(.collapsed):after {
  filter: invert(100%) sepia(0%) saturate(26%) hue-rotate(127deg)
    brightness(170%) contrast(131%);
}
.process-steps-primary > .active:before,
.process-steps-primary > .complete:before {
  background-color: #4c5e74;
}
</style>

<style>
.form-check {
  padding-left: unset !important;
}
.nextStepLeft {
  position: absolute;
  left: 30px;
  bottom: 10px;
}
.previousStepRight {
  position: absolute;
  bottom: 10px;
}
@media (max-width: 991px) {
  .nextStepLeft {
    position: unset !important;
    margin-bottom: 10px;
  }
  .previousStepRight {
    position: unset !important;
    margin-bottom: 10px;
  }
}
@media (max-width: 768px) {
  .accordion {
    margin: auto;
  }
  .errorClass {
    min-height: unset !important;
  }
}
.errorClass {
  min-height: 18px;
}
.filtersContent {
  overflow-y: auto;
  overflow-x: hidden;
}
.existsSemiReserveSession span {
  color: #4c5e74;
  cursor: pointer;
}
.existsSemiReserveSession svg {
  color: red;
  animation: blinkNotification 0.5s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
}
.sessionEmpty {
  background-color: #ffffff;
  transition: 1s;
  background-size: 500% 300%;
  padding: 30px;
  border-radius: 20px;
  animation: shine 2s infinite;
  animation-direction: alternate;
  box-shadow: 1px 1px 10px #4c5e74;
}
@keyframes shine {
  0% {
    background-position: left;
    background-color: #f7e6bd;
  }
}
</style>
